import branchAndServicePoint from 'locales/plus/th/setting/branch-service-point.json'
import defaultLab from 'locales/plus/th/setting/default-labs.json'
import defaultProduct from 'locales/plus/th/setting/default-products.json'
import defaultUsers from 'locales/plus/th/setting/default-users.json'
import defaultSetting from 'locales/plus/th/setting/defaults.json'
import dfManagement from 'locales/plus/th/setting/doctor-fee-managements.json'
import cfManagement from 'locales/plus/th/setting/credit-fee-managements.json'
import finance from 'locales/plus/th/setting/finances.json'
import personalManagement from 'locales/plus/th/setting/personnel-managements.json'
import treatmentCourse from 'locales/plus/th/setting/treatment-courses.json'
import treatmentPlan from 'locales/plus/th/setting/treatment-plans.json'
import treatmentRight from 'locales/plus/th/setting/treatment-rights.json'
import treatment from 'locales/plus/th/setting/treatments.json'
import doctorNote from 'locales/plus/th/setting/doctor-note.json'
import formatForm from 'locales/plus/th/setting/branch-format-form.json'
import breakManagement from 'locales/plus/th/setting/break-management.json'

export const Setting = {
  ...branchAndServicePoint,
  ...defaultLab,
  ...defaultProduct,
  ...defaultUsers,
  ...defaultUsers,
  ...defaultSetting,
  ...dfManagement,
  ...finance,
  ...personalManagement,
  ...treatmentCourse,
  ...treatmentPlan,
  ...treatmentRight,
  ...treatment,
  ...doctorNote,
  ...cfManagement,
  ...formatForm,
  ...breakManagement
}
